import React, { useEffect, useState } from 'react'
import { useNewsUpdateQuery } from '../store/ReactWebSiteApi'
import { Descriptions, Spin } from 'antd'
import Title from './Title'
import dayjs from 'dayjs'

function NewsDesc(props) {
    const [info, setInfo] = useState({
        en_name: '',
    })
    const { data, isSuccess } = useNewsUpdateQuery({ en_id: props.en_id }, { skip: !props.en_id })
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                setInfo({
                    en_dept_id: data.Result.en_dept_id,
                    en_dept_name: data.Result.en_dept_name,
                    en_ctime: data.Result.en_ctime,
                    en_cname: data.Result.en_cname,
                    en_riqi: data.Result.en_riqi,
                    en_name: data.Result.en_name,
                    en_content: data.Result.en_content,
                    en_num: data.Result.en_num,
                    en_bianji: data.Result.en_bianji,
                    en_chushen: data.Result.en_chushen,
                    en_zhongshen: data.Result.en_zhongshen,
                })
            }
        }
    }, [data, isSuccess])

    const items = [
        { key: 'edit', label: '编辑', children: info.en_bianji },
        { key: 'first', label: '初审', children: info.en_chushen },
        { key: 'final', label: '终审', children: info.en_zhongshen },
        { key: 'date', label: '日期', children: <>{dayjs(info.en_ctime).format('YYYY年MM月DD日')}</> },
        { key: 'read', label: '阅读', children: info.en_num },
    ]
    return (
        <>
            {info.en_ctime ? (
                <div style={{ border: '2px solid #eee', margin: '8px 0', padding: '12px' }}>
                    <Title name={info.en_name} />
                    <div dangerouslySetInnerHTML={{ __html: info.en_content }} style={{ fontSize: 15, lineHeight: 1.7, overflowX: 'auto' }} />
                    <Descriptions items={items} column={1} size="small" style={{ marginTop: 16 }} />
                </div>
            ) : (
                <Spin size="large" />
            )}
        </>
    )
}

export default NewsDesc
